module.exports = __webpack_public_path__ + "static/img/storage.58c4f514.png";